import { SelectOption } from "@iddataweb/idw-common-ui/types";

export const INCODE_SMS_USE_IDW_TO_SEND_PROPERTY_ID = "375";
export const INCODE_SMS_DOC_CAPTURE_SO_NAME_PROPERTY_ID = "166";
export const INCODE_SMS_MESSAGING_SERVICE_OPTIONS: Array<SelectOption<string>> = [
    {
        label: "Telesign SMS Messaging Service",
        value: "Telesign SMS Messaging Service"
    },
    {
        label: "Amazon SNS Messaging Service",
        value: "Amazon SNS Messaging Service"
    },
    {
        label: "IDDataWeb SMS Messaging Service",
        value: "IDDataWeb SMS Messaging Service"
    }
];
